// termsOfUse.js

export const termsOfUse = {
        fr: {
                // ----- Mentions légales -----
                mentionLegalTitle: "Mentions légales",

                mentionLegalEditorTitle: "Éditeur du site",
                mentionLegalEditorText: `Le site "The Digital Training Companion" est édité par :
Association Evalution
Avenue de Florimont 30
1006 Lausanne, Suisse
Téléphone : +41 78 217 36 25
Email : contact@evalution-asso.ch
Site : https://www.evalution-asso.ch`,

                mentionLegalHostingTitle: "Hébergement",
                mentionLegalHostingText: `Le site est hébergé par :
Infomaniak Network SA
Rue Eugène-Marziano 25
1227 Les Acacias (GE)
Suisse`,

                mentionLegalDirectorTitle: "Responsable de la publication",
                mentionLegalDirectorText: `Dr. Sunny Avry
Président d'evalution`,

                // ----- CGU -----
                cguTitle: "Conditions Générales d'Utilisation (CGU)",

                article1Title: "Article 1 : Objet",
                article1Text: `Les présentes CGU régissent l'utilisation du site "The Digital Training Companion",
plateforme d'évaluation des formations développée par l'association Evalution.`,

                article2Title: "Article 2 : Accès au site",
                article2Text: `2.1 L'accès au site est libre et gratuit pour tous les utilisateurs.
2.2 Certaines fonctionnalités peuvent nécessiter la création d'un compte utilisateur.
2.3 Les comptes en mode "bac à sable" (sandbox) sont des comptes temporaires qui peuvent
être supprimés à tout moment sans préavis. Les utilisateurs de ces comptes acceptent leur
caractère temporaire et la possible suppression de leurs données.`,

                article3Title: "Article 3 : Services proposés",
                article3Text: `Le site propose des fonctionnalités d'évaluation des formations. L'association Evalution se réserve
le droit de modifier temporairement les services en cas de maintenance nécessaire, avec
notification préalable des utilisateurs.`,

                article4Title: "Article 4 : Propriété intellectuelle",
                article4Text: `4.1 Tous les contenus présents sur le site (textes, images, vidéos, etc.) sont la
propriété exclusive de l'association Evalution ou de leurs auteurs respectifs.`,

                article5Title: "Article 5 : Protection des données personnelles",
                article5Text: `5.1 Collecte des données personnelles
Les données personnelles suivantes sont collectées :
- Nom
- Prénom
- Adresse email

5.2 Finalité du traitement
Ces données sont collectées et traitées uniquement aux fins d'authentification sur le site.

5.3 Durée de conservation
Les données personnelles sont conservées sans limite de durée ou jusqu'à la demande de
suppression par l'utilisateur.

5.4 Droits des utilisateurs
Conformément à la législation suisse sur la protection des données et au RGPD, les utilisateurs
disposent des droits suivants :
- Droit d'accès à leurs données personnelles
- Droit de rectification
- Droit à l'effacement ("droit à l'oubli")
- Droit à la portabilité des données
- Droit d'opposition au traitement

Pour exercer ces droits, contactez-nous à : contact@evalution-asso.ch

5.5 Stockage local
Le site n'utilise pas de cookies classiques mais fait usage du stockage local du navigateur
pour enregistrer un token d'authentification strictement nécessaire au bon fonctionnement du site.
Ce stockage permet de maintenir la session utilisateur active.

5.6 Services tiers et transfert de données
Le site utilise le service AI Tools d'Infomaniak pour certaines fonctionnalités. Cela implique :
- La transmission de certaines données vers les serveurs d'Infomaniak
- Un transfert de données vers les serveurs d'Infomaniak en Suisse
- Le traitement des données selon les conditions d'utilisation d'Infomaniak

Les services d'IA d'Infomaniak garantissent une confidentialité totale des données. Conformément
à leur politique, aucune donnée envoyée via l'API n'est stockée, ni utilisée à des fins de
formation ou d'analyse. Le traitement des données s'effectue en temps réel, exclusivement sur
des serveurs situés en Suisse, dans des infrastructures certifiées ISO 27001. Infomaniak
s'engage à respecter le RGPD ainsi que la législation suisse sur la protection des données.

5.7 Comptes sandbox
Pour les comptes sandbox, les données peuvent être supprimées à tout moment sans préavis.`,

                article6Title: "Article 6 : Obligations des utilisateurs",
                article6Text: `Les utilisateurs s'engagent à :
- Ne pas perturber le fonctionnement du site
- Ne pas tenter d'accéder à des parties non autorisées du site
- Respecter les droits de propriété intellectuelle
- Ne pas diffuser de contenu illégal ou préjudiciable`,

                article7Title: "Article 7 : Responsabilité",
                article7Text: `7.1 L'association Evalution ne peut être tenue responsable des dommages directs ou indirects résultant de
l'utilisation du site.
7.2 L'association Evalution s'efforce d'assurer la disponibilité du site mais ne peut garantir un accès
ininterrompu.
7.3 L'association Evalution n'est pas responsable de la perte de données des comptes sandbox qui peuvent être
supprimés à tout moment.`,

                article8Title: "Article 8 : Modification des CGU",
                article8Text: `L'association Evalution se réserve le droit de modifier les présentes CGU à tout moment. Les utilisateurs
seront informés des modifications substantielles.`,

                article9Title: "Article 9 : Interruption du service",
                article9Text: `9.1 En cas d'arrêt définitif du service, l'association Evalution s'engage à :
- Informer les utilisateurs au minimum 30 jours avant la date d'arrêt
- Permettre aux utilisateurs d'accéder à leurs données pendant cette période
- Préciser les modalités de conservation et de suppression des données
- Fournir un contact pour toute question relative à l'arrêt du service

9.2 La notification d'arrêt sera effectuée par email aux utilisateurs enregistrés et par
affichage sur le site.`,

                article10Title: "Article 10 : Droit applicable et juridiction compétente",
                article10Text: `10.1 Les présentes CGU sont soumises au droit suisse.
10.2 Tout litige relatif à l'interprétation ou l'exécution des présentes CGU relève de la
compétence exclusive des tribunaux de Lausanne, Suisse.`,

                lastUpdate: "Date de dernière mise à jour : 29 août 2026"
        },

        // --------------------------------------------------------------------

        en: {
                mentionLegalTitle: "Legal Notice",

                mentionLegalEditorTitle: "Publisher of the site",
                mentionLegalEditorText: `The website "The Digital Training Companion" is published by:
Association Evalution
Avenue de Florimont 30
1006 Lausanne, Switzerland
Phone: +41 78 217 36 25
Email: contact@evalution-asso.ch
Website: https://www.evalution-asso.ch`,

                mentionLegalHostingTitle: "Hosting",
                mentionLegalHostingText: `The site is hosted by:
Infomaniak Network SA
Rue Eugène-Marziano 25
1227 Les Acacias (GE)
Switzerland`,

                mentionLegalDirectorTitle: "Publication Director",
                mentionLegalDirectorText: `Dr. Sunny Avry
President of evalution`,

                cguTitle: "General Terms of Use (GTU)",

                article1Title: "Article 1: Purpose",
                article1Text: `These GTU govern the use of "The Digital Training Companion," a training-evaluation
platform developed by the Evalution association.`,

                article2Title: "Article 2: Site Access",
                article2Text: `2.1 Access to the site is free for all users.
2.2 Some features may require creating a user account.
2.3 "Sandbox" accounts are temporary accounts that may be deleted at any time without notice.
Users of these accounts acknowledge their temporary nature and the possible deletion of their data.`,

                article3Title: "Article 3: Services Offered",
                article3Text: `The site provides functionalities to evaluate training programs. The Evalution association reserves the
right to modify these services temporarily for necessary maintenance, with prior notification
to users.`,

                article4Title: "Article 4: Intellectual Property",
                article4Text: `4.1 All content on the site (texts, images, videos, etc.) is the exclusive property
of the Evalution association or their respective authors.`,

                article5Title: "Article 5: Protection of Personal Data",
                article5Text: `5.1 Collection of personal data
The following personal data is collected:
- First name
- Last name
- Email address

5.2 Purpose of processing
This data is collected and processed solely for authentication purposes on the site.

5.3 Retention period
Personal data is retained indefinitely or until the user requests its deletion.

5.4 User rights
In accordance with Swiss data protection legislation and the GDPR, users have the following rights:
- Right of access to their personal data
- Right to rectification
- Right to erasure ("right to be forgotten")
- Right to data portability
- Right to object to processing

To exercise these rights, contact: contact@evalution-asso.ch

5.5 Local storage
The site does not use traditional cookies but uses the browser's local storage to save an
authentication token strictly necessary for the proper functioning of the site. This storage
keeps the user session active.

5.6 Third-party services and data transfer
The site uses Infomaniak's AI Tools for certain functionalities. This implies:
- The transmission of some data to Infomaniak's servers
- Data transfer to Infomaniak servers in Switzerland
- Data processing under Infomaniak's terms of use

Infomaniak's AI services guarantee full confidentiality of data. According to their policy,
no data sent via the API is stored or used for training or analysis. Data is processed in
real time, exclusively on servers located in Switzerland, in ISO 27001-certified infrastructures.
Infomaniak is committed to complying with the GDPR as well as Swiss data protection legislation.

5.7 Sandbox accounts
For sandbox accounts, data may be deleted at any time without notice.`,

                article6Title: "Article 6: User Obligations",
                article6Text: `Users agree to:
- Not disrupt the operation of the site
- Not attempt to access unauthorized parts of the site
- Respect intellectual property rights
- Not distribute illegal or harmful content`,

                article7Title: "Article 7: Liability",
                article7Text: `7.1 The Evalution association cannot be held responsible for direct or indirect damages resulting from
the use of the site.
7.2 The Evalution association strives to ensure site availability but cannot guarantee uninterrupted access.
7.3 The Evalution association is not responsible for the loss of data in sandbox accounts, which may be deleted
at any time.`,

                article8Title: "Article 8: Modification of the GTU",
                article8Text: `The Evalution association reserves the right to modify these GTU at any time. Users will be informed
of substantial changes.`,

                article9Title: "Article 9: Service Interruption",
                article9Text: `9.1 In the event of permanent service discontinuation, the Evalution association commits to:
- Inform users at least 30 days before the discontinuation date
- Allow users to access their data during that period
- Specify the conditions for data retention and deletion
- Provide a contact for any questions related to the service discontinuation

9.2 Notice of discontinuation will be given via email to registered users and by posting
on the site.`,

                article10Title: "Article 10: Applicable Law and Jurisdiction",
                article10Text: `10.1 These GTU are governed by Swiss law.
10.2 Any dispute regarding the interpretation or execution of these GTU falls under the
exclusive jurisdiction of the courts of Lausanne, Switzerland.`,

                lastUpdate: "Last updated: August 29, 2026"
        },

        // --------------------------------------------------------------------

        de: {
                mentionLegalTitle: "Rechtliche Hinweise",

                mentionLegalEditorTitle: "Herausgeber der Website",
                mentionLegalEditorText: `Die Website "The Digital Training Companion" wird herausgegeben von:
Verein Evalution
Avenue de Florimont 30
1006 Lausanne, Schweiz
Telefon: +41 78 217 36 25
E-Mail: contact@evalution-asso.ch
Website: https://www.evalution-asso.ch`,

                mentionLegalHostingTitle: "Hosting",
                mentionLegalHostingText: `Die Website wird gehostet von:
Infomaniak Network SA
Rue Eugène-Marziano 25
1227 Les Acacias (GE)
Schweiz`,

                mentionLegalDirectorTitle: "Verantwortlicher für die Veröffentlichung",
                mentionLegalDirectorText: `Dr. Sunny Avry
Präsident von evalution`,

                cguTitle: "Allgemeine Nutzungsbedingungen (ANB)",

                article1Title: "Artikel 1: Zweck",
                article1Text: `Diese ANB regeln die Nutzung von "The Digital Training Companion", einer Plattform
zur Bewertung von Schulungen, die vom Verein Evalution entwickelt wurde.`,

                article2Title: "Artikel 2: Zugriff auf die Website",
                article2Text: `2.1 Der Zugriff auf die Website ist für alle Benutzer kostenlos.
2.2 Einige Funktionen können das Anlegen eines Benutzerkontos erfordern.
2.3 "Sandbox"-Konten sind temporäre Konten, die jederzeit ohne Vorankündigung gelöscht
werden können. Benutzer dieser Konten akzeptieren deren vorübergehenden Charakter und die
mögliche Löschung ihrer Daten.`,

                article3Title: "Artikel 3: Angebotene Dienste",
                article3Text: `Die Website bietet Funktionen zur Bewertung von Schulungen. Der Verein Evalution behält sich
das Recht vor, diese Dienste bei Bedarf vorübergehend zu ändern (z.B. für Wartungsarbeiten), 
und informiert die Benutzer im Voraus.`,

                article4Title: "Artikel 4: Geistiges Eigentum",
                article4Text: `4.1 Sämtliche Inhalte auf der Website (Texte, Bilder, Videos usw.) sind Eigentum 
des Vereins Evalution oder ihrer jeweiligen Autoren.`,

                article5Title: "Artikel 5: Schutz personenbezogener Daten",
                article5Text: `5.1 Erhebung personenbezogener Daten
Folgende personenbezogene Daten werden erhoben:
- Vorname
- Nachname
- E-Mail-Adresse

5.2 Zweck der Verarbeitung
Diese Daten werden ausschließlich zum Zweck der Authentifizierung auf der Website erhoben und verarbeitet.

5.3 Aufbewahrungsdauer
Die personenbezogenen Daten werden zeitlich unbegrenzt oder bis zur Löschanfrage durch den Benutzer aufbewahrt.

5.4 Rechte der Benutzer
Gemäß schweizerischem Datenschutzrecht und der DSGVO haben Benutzer folgende Rechte:
- Recht auf Auskunft über ihre personenbezogenen Daten
- Recht auf Berichtigung
- Recht auf Löschung ("Recht auf Vergessenwerden")
- Recht auf Datenübertragbarkeit
- Widerspruchsrecht

Zur Ausübung dieser Rechte wenden Sie sich bitte an: contact@evalution-asso.ch

5.5 Lokaler Speicher
Die Website verwendet keine herkömmlichen Cookies, sondern den lokalen Speicher des Browsers,
um ein Authentifizierungs-Token zu speichern, das für die ordnungsgemäße Funktion der Website
unbedingt erforderlich ist. Dieser Speicher ermöglicht es, die Benutzersitzung aufrechtzuerhalten.

5.6 Dienste Dritter und Datenübertragung
Die Website nutzt die AI-Tools von Infomaniak für bestimmte Funktionen. Dies bedeutet:
- Die Übermittlung bestimmter Daten an die Server von Infomaniak
- Die Übertragung von Daten an Infomaniak-Server in der Schweiz
- Die Verarbeitung der Daten gemäß den Nutzungsbedingungen von Infomaniak

Die KI-Dienste von Infomaniak gewährleisten die vollständige Vertraulichkeit der Daten.
Nach deren Richtlinie werden über die API gesendete Daten weder gespeichert noch für Training
oder Analysen verwendet. Die Datenverarbeitung erfolgt in Echtzeit, ausschließlich auf
Servern in der Schweiz, in ISO-27001-zertifizierten Infrastrukturen. Infomaniak verpflichtet
sich zur Einhaltung der DSGVO sowie des schweizerischen Datenschutzrechts.

5.7 Sandbox-Konten
Bei Sandbox-Konten können Daten jederzeit ohne Vorankündigung gelöscht werden.`,

                article6Title: "Artikel 6: Pflichten der Benutzer",
                article6Text: `Die Benutzer verpflichten sich:
- Den Betrieb der Website nicht zu stören
- Nicht zu versuchen, auf nicht autorisierte Teile der Website zuzugreifen
- Geistige Eigentumsrechte zu respektieren
- Keine illegalen oder schädlichen Inhalte zu verbreiten`,

                article7Title: "Artikel 7: Haftung",
                article7Text: `7.1 Der Verein Evalution haftet nicht für direkte oder indirekte Schäden, die durch die Nutzung
der Website entstehen.
7.2 Der Verein Evalution bemüht sich um die Verfügbarkeit der Website, kann jedoch keinen
ununterbrochenen Zugriff garantieren.
7.3 Der Verein Evalution ist nicht verantwortlich für den Verlust von Daten in Sandbox-Konten, die
jederzeit gelöscht werden können.`,

                article8Title: "Artikel 8: Änderung der ANB",
                article8Text: `Der Verein Evalution behält sich das Recht vor, diese ANB jederzeit zu ändern. Die Benutzer
werden über wesentliche Änderungen informiert.`,

                article9Title: "Artikel 9: Unterbrechung des Dienstes",
                article9Text: `9.1 Im Falle einer endgültigen Einstellung des Dienstes verpflichtet sich der Verein Evalution:
- Die Benutzer mindestens 30 Tage vor dem Enddatum zu informieren
- Den Benutzern während dieses Zeitraums den Zugriff auf ihre Daten zu ermöglichen
- Die Bedingungen für die Aufbewahrung und Löschung von Daten anzugeben
- Einen Kontakt für alle Fragen zur Einstellung des Dienstes bereitzustellen

9.2 Die Mitteilung über die Einstellung erfolgt per E-Mail an registrierte Benutzer und
durch einen Hinweis auf der Website.`,

                article10Title: "Artikel 10: Anwendbares Recht und Gerichtsstand",
                article10Text: `10.1 Diese ANB unterliegen dem schweizerischen Recht.
10.2 Alle Streitigkeiten im Zusammenhang mit der Auslegung oder Ausführung dieser ANB unterliegen
der ausschließlichen Zuständigkeit der Gerichte von Lausanne, Schweiz.`,

                lastUpdate: "Letzte Aktualisierung: 29. August 2026"
        },

        // --------------------------------------------------------------------

        it: {
                mentionLegalTitle: "Note legali",

                mentionLegalEditorTitle: "Editore del sito",
                mentionLegalEditorText: `Il sito "The Digital Training Companion" è pubblicato da:
Associazione Evalution
Avenue de Florimont 30
1006 Losanna, Svizzera
Telefono: +41 78 217 36 25
Email: contact@evalution-asso.ch
Sito: https://www.evalution-asso.ch`,

                mentionLegalHostingTitle: "Hosting",
                mentionLegalHostingText: `Il sito è ospitato da:
Infomaniak Network SA
Rue Eugène-Marziano 25
1227 Les Acacias (GE)
Svizzera`,

                mentionLegalDirectorTitle: "Direttore della pubblicazione",
                mentionLegalDirectorText: `Dr. Sunny Avry
Presidente di evalution`,

                cguTitle: "Termini Generali di Utilizzo (TGU)",

                article1Title: "Articolo 1: Oggetto",
                article1Text: `I presenti TGU regolano l'uso di "The Digital Training Companion", una piattaforma 
di valutazione della formazione sviluppata dall'associazione Evalution.`,

                article2Title: "Articolo 2: Accesso al sito",
                article2Text: `2.1 L'accesso al sito è gratuito per tutti gli utenti.
2.2 Alcune funzionalità potrebbero richiedere la creazione di un account utente.
2.3 Gli account in modalità "sandbox" sono account temporanei che possono essere eliminati 
in qualsiasi momento senza preavviso. Gli utenti di questi account accettano il loro carattere 
temporaneo e la possibile cancellazione dei loro dati.`,

                article3Title: "Articolo 3: Servizi offerti",
                article3Text: `Il sito offre funzionalità per valutare i programmi di formazione. L'associazione Evalution si riserva 
il diritto di modificare temporaneamente i servizi per necessità di manutenzione, con preavviso 
agli utenti.`,

                article4Title: "Articolo 4: Proprietà intellettuale",
                article4Text: `4.1 Tutti i contenuti presenti sul sito (testi, immagini, video, ecc.) sono di 
proprietà esclusiva dell'associazione Evalution o dei rispettivi autori.`,

                article5Title: "Articolo 5: Protezione dei dati personali",
                article5Text: `5.1 Raccolta dei dati personali
Vengono raccolti i seguenti dati personali:
- Nome
- Cognome
- Indirizzo email

5.2 Finalità del trattamento
Questi dati sono raccolti e trattati esclusivamente per scopi di autenticazione sul sito.

5.3 Periodo di conservazione
I dati personali sono conservati a tempo indeterminato o fino alla richiesta di 
cancellazione da parte dell'utente.

5.4 Diritti degli utenti
In conformità con la legislazione svizzera sulla protezione dei dati e il GDPR, gli utenti 
hanno i seguenti diritti:
- Diritto di accesso ai propri dati personali
- Diritto di rettifica
- Diritto alla cancellazione ("diritto all'oblio")
- Diritto alla portabilità dei dati
- Diritto di opposizione al trattamento

Per esercitare questi diritti, contattare: contact@evalution-asso.ch

5.5 Archiviazione locale
Il sito non utilizza cookie tradizionali ma utilizza l'archiviazione locale del browser per 
salvare un token di autenticazione strettamente necessario per il corretto funzionamento 
del sito. Questo archivio mantiene attiva la sessione utente.

5.6 Servizi di terze parti e trasferimento dei dati
Il sito utilizza gli strumenti AI di Infomaniak per alcune funzionalità. Ciò implica:
- La trasmissione di alcuni dati ai server di Infomaniak
- Il trasferimento dei dati ai server di Infomaniak in Svizzera
- L'elaborazione dei dati secondo i termini di utilizzo di Infomaniak

I servizi AI di Infomaniak garantiscono la totale riservatezza dei dati. Secondo la loro 
politica, nessun dato inviato tramite API viene memorizzato o utilizzato per formazione 
o analisi. L'elaborazione dei dati avviene in tempo reale, esclusivamente su server 
situati in Svizzera, in infrastrutture certificate ISO 27001. Infomaniak si impegna a 
rispettare il GDPR e la legislazione svizzera sulla protezione dei dati.

5.7 Account sandbox
Per gli account sandbox, i dati possono essere eliminati in qualsiasi momento senza preavviso.`,

                article6Title: "Articolo 6: Obblighi degli utenti",
                article6Text: `Gli utenti si impegnano a:
- Non disturbare il funzionamento del sito
- Non tentare di accedere a parti non autorizzate del sito
- Rispettare i diritti di proprietà intellettuale
- Non diffondere contenuti illegali o dannosi`,

                article7Title: "Articolo 7: Responsabilità",
                article7Text: `7.1 L'associazione Evalution non può essere ritenuta responsabile per danni diretti o indiretti 
derivanti dall'uso del sito.
7.2 L'associazione Evalution si sforza di garantire la disponibilità del sito ma non può assicurare 
un accesso ininterrotto.
7.3 L'associazione Evalution non è responsabile della perdita di dati negli account sandbox che possono 
essere eliminati in qualsiasi momento.`,

                article8Title: "Articolo 8: Modifica dei TGU",
                article8Text: `L'associazione Evalution si riserva il diritto di modificare i presenti TGU in qualsiasi momento. 
Gli utenti saranno informati di modifiche sostanziali.`,

                article9Title: "Articolo 9: Interruzione del servizio",
                article9Text: `9.1 In caso di interruzione definitiva del servizio, l'associazione Evalution si impegna a:
- Informare gli utenti almeno 30 giorni prima della data di interruzione
- Consentire agli utenti di accedere ai propri dati durante questo periodo
- Specificare le modalità di conservazione e cancellazione dei dati
- Fornire un contatto per qualsiasi domanda relativa all'interruzione del servizio

9.2 La notifica di interruzione sarà effettuata via email agli utenti registrati e 
mediante avviso sul sito.`,

                article10Title: "Articolo 10: Legge applicabile e giurisdizione competente",
                article10Text: `10.1 I presenti TGU sono soggetti al diritto svizzero.
10.2 Qualsiasi controversia relativa all'interpretazione o all'esecuzione dei presenti 
TGU rientra nella giurisdizione esclusiva dei tribunali di Losanna, Svizzera.`,

                lastUpdate: "Ultimo aggiornamento: 29 agosto 2026"
        },

        // --------------------------------------------------------------------

        es: {
                mentionLegalTitle: "Aviso legal",

                mentionLegalEditorTitle: "Editor del sitio",
                mentionLegalEditorText: `El sitio web "The Digital Training Companion" es publicado por:
Asociación Evalution
Avenue de Florimont 30
1006 Lausana, Suiza
Teléfono: +41 78 217 36 25
Email: contact@evalution-asso.ch
Sitio: https://www.evalution-asso.ch`,

                mentionLegalHostingTitle: "Alojamiento",
                mentionLegalHostingText: `El sitio está alojado por:
Infomaniak Network SA
Rue Eugène-Marziano 25
1227 Les Acacias (GE)
Suiza`,

                mentionLegalDirectorTitle: "Director de publicación",
                mentionLegalDirectorText: `Dr. Sunny Avry
Presidente de evalution`,

                cguTitle: "Términos Generales de Uso (TGU)",

                article1Title: "Artículo 1: Objeto",
                article1Text: `Los presentes TGU regulan el uso de "The Digital Training Companion", una plataforma 
de evaluación de formaciones desarrollada por la asociación Evalution.`,

                article2Title: "Artículo 2: Acceso al sitio",
                article2Text: `2.1 El acceso al sitio es gratuito para todos los usuarios.
2.2 Algunas funcionalidades pueden requerir la creación de una cuenta de usuario.
2.3 Las cuentas en modo "sandbox" son cuentas temporales que pueden ser eliminadas en 
cualquier momento sin previo aviso. Los usuarios de estas cuentas aceptan su carácter 
temporal y la posible eliminación de sus datos.`,

                article3Title: "Artículo 3: Servicios ofrecidos",
                article3Text: `El sitio ofrece funcionalidades para evaluar programas de formación. La asociación Evalution se 
reserva el derecho de modificar temporalmente los servicios por necesidades de mantenimiento, 
con previo aviso a los usuarios.`,

                article4Title: "Artículo 4: Propiedad intelectual",
                article4Text: `4.1 Todo el contenido del sitio (textos, imágenes, videos, etc.) es propiedad 
exclusiva de la asociación Evalution o de sus respectivos autores.`,

                article5Title: "Artículo 5: Protección de datos personales",
                article5Text: `5.1 Recogida de datos personales
Se recogen los siguientes datos personales:
- Nombre
- Apellido
- Dirección de correo electrónico

5.2 Finalidad del tratamiento
Estos datos se recogen y tratan únicamente para fines de autenticación en el sitio.

5.3 Periodo de conservación
Los datos personales se conservan sin límite de tiempo o hasta la solicitud de 
eliminación por parte del usuario.

5.4 Derechos de los usuarios
De acuerdo con la legislación suiza de protección de datos y el RGPD, los usuarios 
tienen los siguientes derechos:
- Derecho de acceso a sus datos personales
- Derecho de rectificación
- Derecho al olvido
- Derecho a la portabilidad de los datos
- Derecho de oposición al tratamiento

Para ejercer estos derechos, contactar con: contact@evalution-asso.ch

5.5 Almacenamiento local
El sitio no utiliza cookies tradicionales pero sí el almacenamiento local del navegador 
para guardar un token de autenticación estrictamente necesario para el correcto 
funcionamiento del sitio. Este almacenamiento mantiene activa la sesión del usuario.

5.6 Servicios de terceros y transferencia de datos
El sitio utiliza las herramientas AI de Infomaniak para ciertas funcionalidades. Esto implica:
- La transmisión de algunos datos a los servidores de Infomaniak
- La transferencia de datos a servidores de Infomaniak en Suiza
- El tratamiento de datos según las condiciones de uso de Infomaniak

Los servicios AI de Infomaniak garantizan total confidencialidad de los datos. Según su 
política, ningún dato enviado vía API es almacenado o utilizado para entrenamiento o 
análisis. El procesamiento de datos se realiza en tiempo real, exclusivamente en 
servidores ubicados en Suiza, en infraestructuras certificadas ISO 27001. Infomaniak 
se compromete a cumplir con el RGPD y la legislación suiza de protección de datos.

5.7 Cuentas sandbox
Para las cuentas sandbox, los datos pueden ser eliminados en cualquier momento sin previo aviso.`,

                article6Title: "Artículo 6: Obligaciones de los usuarios",
                article6Text: `Los usuarios se comprometen a:
- No perturbar el funcionamiento del sitio
- No intentar acceder a partes no autorizadas del sitio
- Respetar los derechos de propiedad intelectual
- No difundir contenido ilegal o perjudicial`,

                article7Title: "Artículo 7: Responsabilidad",
                article7Text: `7.1 La asociación Evalution no puede ser responsable de daños directos o indirectos resultantes 
del uso del sitio.
7.2 La asociación Evalution se esfuerza por garantizar la disponibilidad del sitio pero no puede 
asegurar un acceso ininterrumpido.
7.3 La asociación Evalution no es responsable de la pérdida de datos en cuentas sandbox que pueden 
ser eliminadas en cualquier momento.`,

                article8Title: "Artículo 8: Modificación de los TGU",
                article8Text: `La asociación Evalution se reserva el derecho de modificar los presentes TGU en cualquier momento. 
Los usuarios serán informados de cambios sustanciales.`,

                article9Title: "Artículo 9: Interrupción del servicio",
                article9Text: `9.1 En caso de interrupción definitiva del servicio, la asociación Evalution se compromete a:
- Informar a los usuarios al menos 30 días antes de la fecha de interrupción
- Permitir a los usuarios acceder a sus datos durante este período
- Especificar las condiciones de conservación y eliminación de datos
- Proporcionar un contacto para cualquier pregunta relacionada con la interrupción del servicio

9.2 La notificación de interrupción se realizará por correo electrónico a los usuarios 
registrados y mediante aviso en el sitio.`,

                article10Title: "Artículo 10: Ley aplicable y jurisdicción competente",
                article10Text: `10.1 Los presentes TGU se rigen por el derecho suizo.
10.2 Cualquier disputa relativa a la interpretación o ejecución de los presentes TGU 
corresponde a la jurisdicción exclusiva de los tribunales de Lausana, Suiza.`,

                lastUpdate: "Última actualización: 29 de agosto de 2026"
        }
};
